function parsePrice(value: string | number): number {
	if (typeof value === "number") return value;

	// Remove whitespace and handle Norwegian ",-" format (e.g. "499,-", "1 299,-")
	const normalized = value
		.replace(/\s/g, "")
		.replace(/,-$/, "") // Strip trailing ",-"
		.replace(",", "."); // Convert decimal comma to dot (e.g. "499,99" -> "499.99")

	return Number(normalized);
}

export function formatDiscountPrice({
	previousPrice,
	price,
}: {
	previousPrice: string | number;
	price: string | number;
}) {
	if (previousPrice === null || previousPrice === undefined) return "";

	const previousPriceNumber = parsePrice(previousPrice);
	const priceNumber = parsePrice(price);

	if (!Number.isFinite(previousPriceNumber) || !Number.isFinite(priceNumber))
		return "";

	const isNegative = previousPriceNumber - priceNumber < 0;
	const whole = Math.round(Math.abs(previousPriceNumber - priceNumber));

	// nb-NO uses a non-breaking space for grouping; normalize to regular space
	const grouped = new Intl.NumberFormat("nb-NO", {
		useGrouping: true,
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	})
		.format(whole)
		.replace(/\u00A0/g, " ");

	return (isNegative ? "-" : "") + grouped + ",-";
}
